<template>
    <div class="wrapper-landing">
      <LandingHero
        title="Crea la tua lista di nozze multi-store & gratuita"
        subtitle="Salva tutto ciò che desideri e condividilo con eleganza"
        origin="listaboda"
        listType="wedding"
        buttonText="Inizia la tua lista ora"
        lang="it-IT"
        logoStyle="white"
      >
        <template v-slot:cover>
          <source
            media="(max-width: 991px)"
            class=""
            srcset="../../assets/img/landings/cover-celebracion-boda-d.jpg"
            alt=""
            loading="lazy"
          />
          <img
            class="ln-hero__inset"
            src="../../assets/img/landings/cover-celebracion-boda-d.jpg"
            alt=""
            loading="lazy"
          />
        </template>
      </LandingHero>
      <main class="bg-cercles">
        <LandingAppRatings />
  
        <section class="bb-container">
          <LandingFeaturesSimple title="Hai bisogno di una lista HelloBB se:"
          :use-carousel="false"
          >
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-q.svg" alt="" />
              </template>
              <template slot="title">
                La tua famiglia e i tuoi amici continuano a chiederti cosa vuoi per le nozze.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-mobile-cart.svg" alt="" />
              </template>
              <template slot="title"> Vuoi scegliere articoli da negozi diversi. </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-hand-heart.svg" alt="" />
              </template>
              <template slot="title">
                Cerchi un modo semplice e carino per condividere i tuoi desideri.
              </template>
            </LandingFeaturesSimpleItem>
            <LandingFeaturesSimpleItem>
              <template slot="ico">
                <img src="../../assets/img/ico/ico-color-clipboard.svg" alt="" />
              </template>
              <template slot="title">
                Ti piace organizzarti e non vuoi dimenticare nulla.
              </template>
            </LandingFeaturesSimpleItem>
          </LandingFeaturesSimple>
        </section>
      </main>
  
      <LandingFeaturesCover title="Una lista piena di cose belle">
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/landings/cover-retailers-box-it.png" alt="" />
          </template>
          <template slot="titulo">
            Richiedi qualsiasi modello, di qualsiasi marca, da qualsiasi negozio.
          </template>
  
          <template slot="descripcion">
            <p>
                Copia un link e aggiungilo alla tua lista. Libertà totale per scegliere esattamente ciò che desideri.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/cover-regalos-efectivo.svg" alt="" />
          </template>
          <template slot="titulo"> Raccogli denaro senza commissioni </template>
  
          <template slot="descripcion">
            <p>
                La tua famiglia e i tuoi amici potranno regalarti articoli o inviarti denaro per acquistare ciò che preferisci. Come proprietario della lista, non paghi nulla per ricevere denaro.
            </p>
          </template>
        </LandingFeaturesCoverItem>
        <!-- <LandingFeaturesCoverItem>
          <template slot="cover">
            <img src="../../assets/img/covers/mockup-aportacions-it.png" alt="" />
          </template>
          <template slot="titulo"> Possibilità di dividere le spese dei prodotti più costosi </template>
  
          <template slot="descripcion">
            <p>
                La tua famiglia e i tuoi amici potranno contribuire all'acquisto dei prodotti più costosi.
            </p>
          </template>
        </LandingFeaturesCoverItem> -->
        <FeaturesCoverItemListUpdate lang="it-IT" />
      </LandingFeaturesCover>
  
      <main class="bg-cercles">
        <section class="bb-container">
          <LandingReviewsWedding lang="it-IT" />
        </section>
      </main>
  
      <LandingComoCols title="Come funziona?" subtitle="La tua lista di nozze digitale">
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-click.svg" alt="" />
          </template>
          <template slot="titulo">Scegli ciò che desideri</template>
          <template slot="descripcion">
            <p>
                Seleziona gli articoli che vuoi da qualsiasi negozio online, copia il link su HelloBB e salvalo.
            </p>
            <p>
              Puoi anche avere un salvadanaio per raccogliere denaro per quello che vuoi.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-share.svg" alt="" />
          </template>
          <template slot="titulo">Condividi i tuoi desideri</template>
          <template slot="descripcion">
            <p>Quando sei pronto, condividi la tua lista con familiari e amici.</p>
            <p>
                Invia loro un link per accedere a una lista personalizzata, da qualsiasi dispositivo e senza bisogno di registrazione.
            </p>
          </template>
        </LandingComoColsItem>
        <LandingComoColsItem>
          <template slot="icono">
            <img src="../../assets/img/ico/ico-max-gift.svg" alt="" />
          </template>
          <template slot="titulo">Ricevi i tuoi regali</template>
          <template slot="descripcion">
            <p>
                I tuoi cari potranno scegliere il regalo che preferiscono dalla tua lista e acquistarlo. Potranno inviartelo direttamente o tenerlo per offrirlo durante una visita.
            </p>
            <p>
                Per evitare doppioni, potranno segnare che l'articolo è già stato regalato.
            </p>
          </template>
        </LandingComoColsItem>
      </LandingComoCols>
  
      <LandingFooter lang="it-IT" />
    </div>
  </template>
  
  <script>
  import LandingFeaturesSlider from "./components/LandingFeaturesSlider.vue";
  
  import LandingFeaturesSimple from "./components/LandingFeaturesSimple.vue";
  import LandingFeaturesSimpleItem from "./components/LandingFeaturesSimpleItem.vue";
  
  import LandingHero from "./components/LandingHero.vue";
  import LandingAppRatings from "./components/LandingAppRatings.vue";
  import LandingFeaturesCover from "./components/LandingFeaturesCover";
  import LandingFeaturesCoverItem from "./components/LandingFeaturesCoverItem";
  import LandingReviewsWedding from "./components/LandingReviewsWedding.vue";
  import LandingHablan from "./components/LandingHablan.vue";
  import LandingFooter from "./components/LandingFooter.vue";
  
  import LandingComoCards from "./components/LandingComoCards.vue";
  import LandingComoCardsItem from "./components/LandingComoCardsItem.vue";
  import LandingComoColsItem from "./components/LandingComoColsItem.vue";
  import LandingComoCols from "./components/LandingComoCols.vue";

  import FeaturesCoverItemListUpdate from "./components/FeaturesCoverItemListUpdate.vue";
  
  // import bbButton from "../../components/buttons/bbButton.vue";
  
  export default {
    name: "LandingWeddingIT",
    metaInfo() {
      return {
        title: "HelloBB: la tua lista di nozze multi-store & gratuita",
        htmlAttrs: {
          lang: "it",
        },
        meta: [
          { name: "description", content: "Crea la lista delle tue nozze con HelloBB." },
          // { name: "robots", content: "noindex" },
        ],
      };
    },
    components: {
      LandingComoCols,
      LandingComoColsItem,
      LandingAppRatings,
      LandingHablan,
      LandingReviewsWedding,
      LandingFooter,
      LandingHero,
      LandingFeaturesCover,
      LandingFeaturesCoverItem,
      LandingFeaturesSlider,
      LandingFeaturesSimple,
      LandingFeaturesSimpleItem,
      LandingComoCards,
      LandingComoCardsItem,
      FeaturesCoverItemListUpdate,
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
